
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import StickyFilterContainer from '@/components/reports-v3/components/pages/StickyFilterContainer.vue';
import QuotationTrackingTable from '@/components/reports-v3/components/codedWidgets/sales/SalesOpenQuotationsTrackingTable.vue';
import SalesOrderTrackingTable from '@/components/reports-v3/components/codedWidgets/sales/SalesPendingSalesOrderTable.vue';
import SalesConversionRateBarChart from '@/components/reports-v3/components/codedWidgets/sales/SalesQuotationConversionRateByDocumentBarChart.vue';
import userx from '@/store/modules/userx';
import router from '@/router';
import LastSync from '@/components/LastSync.vue';
import AgentsListFilter from '@/components/reports-v3/components/filters/AgentsListFilter.vue';
import CustomerListFilter from '@/components/reports-v3/components/filters/CustomerListFilter.vue';
import AreaListFilter from '@/components/reports-v3/components/filters/AreaListFilter.vue';
@Component({
    components: {
        StickyFilterContainer,
        QuotationTrackingTable,
        SalesOrderTrackingTable,
        SalesConversionRateBarChart,
        LastSync,
        AgentsListFilter,
        CustomerListFilter,
        AreaListFilter,
    },
})
export default class SalesProgress extends Vue {
    public selectedAgents: string[] = [];
    public selectedCustomers: string[] = [];
    public selectedAreas: string[] = [];

    public mounted() {
        this.track();
    }

    public track() {
        this.$ga.set('userId', userx.user!.uid + '_' + userx.user!.email);
        this.$ga.page(router);
    }

    public onHovering(value: boolean, filterId: string) {
        this.$emit('hovering', value, filterId);
    }

    public onEditing(value: boolean, filterId: string) {
        this.$emit('editing', value, filterId);
    }
}
